import PowerRequests from '../../server/power';
import { addLoading, removeLoading } from './loading';

export const getListPower = (
  powerRangeId,
  limit,
  skip,
  search,
  orderBy = 'DESC',
  field = 'createdAt',
  loading = true,
) => async (dispatch) => {
  if (loading) dispatch(addLoading());
  try {
    const result = await PowerRequests.getListPower(powerRangeId, limit, skip, search, orderBy, field);
    return result;
  } finally {
    if (loading) dispatch(removeLoading());
  }
};

export const getOptionsPower = search => async () => {
  const listPower = await PowerRequests.getOptionsPower(search);
  return listPower;
};

export const createPower = newPower => async (dispatch) => {
  dispatch(addLoading());
  try {
    await PowerRequests.createPower(newPower);
  } finally {
    dispatch(removeLoading());
  }
};

export const updatePower = updPower => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await PowerRequests.updatePower(updPower);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};
